import { keyframes, styled } from "goober";
import { Icon } from "./Icon";

const pulseOuter = keyframes`
  0% {
    opacity: 0.8;
    transform: scale(0.5);
  }
  66% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
`;

const LiveDot = styled("div")`
  position: relative;
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 16px;
    margin-left: -8px;
    margin-top: -8px;
    border-radius: 50%;
    background: var(--green-600);
    animation: ${pulseOuter} 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--green-600);
  }
`;

export function LiveIndicator({ paused = false }: { paused?: boolean } = {}) {
  if (paused) {
    return <Icon name="circle-pause" size={16} color="var(--text-secondary)" />;
  }
  return <LiveDot />;
}
